// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guided-highlight-hover-tooltip {
  position: fixed;
  z-index: 10020;
  box-sizing: border-box;
  padding: 0.8rem;
  border: 1px solid #3b82f6;
  border-radius: 0.7rem;
  background: #172554;
  color: #dbeafe;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);
  pointer-events: none;
}

.guided-highlight-hover-tooltip p {
  margin: 0;
}

.guided-highlight-hover-tooltip__message {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
}

.guided-highlight-hover-tooltip__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border: 1px solid #ffffff;
  border-radius: 999px;
  background: #ffffff;
}

.guided-highlight-hover-tooltip__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.guided-highlight-hover-tooltip__meaning {
  font-size: 0.78rem;
  line-height: 1.35;
  font-weight: 700;
}

.guided-highlight-hover-tooltip__purpose {
  margin-top: 0.32rem !important;
  font-size: 0.77rem;
  line-height: 1.4;
}

.guided-highlight-hover-tooltip__footer {
  margin-top: 0.62rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(96, 165, 250, 0.18);
  font-size: 0.68rem;
  line-height: 1.35;
  color: #bfdbfe;
}

.guided-highlight-hover-tooltip__footer strong {
  margin-left: 0.2rem;
  color: #93c5fd;
  font-weight: 700;
}

.guided-highlight-hover-tooltip.light {
  border-color: #bfdbfe;
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.2);
}

.light .guided-highlight-hover-tooltip__purpose {
  color: #334155;
}

.light .guided-highlight-hover-tooltip__footer {
  border-top-color: rgba(59, 130, 246, 0.16);
  color: #4b5563;
}

.light .guided-highlight-hover-tooltip__footer strong {
  color: #1d4ed8;
}
`, "",{"version":3,"sources":["webpack://./src/components/overlays/GuidedHighlightHoverTooltip.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".guided-highlight-hover-tooltip {\n  position: fixed;\n  z-index: 10020;\n  box-sizing: border-box;\n  padding: 0.8rem;\n  border: 1px solid #3b82f6;\n  border-radius: 0.7rem;\n  background: #172554;\n  color: #dbeafe;\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);\n  pointer-events: none;\n}\n\n.guided-highlight-hover-tooltip p {\n  margin: 0;\n}\n\n.guided-highlight-hover-tooltip__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n}\n\n.guided-highlight-hover-tooltip__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  overflow: hidden;\n  border: 1px solid #ffffff;\n  border-radius: 999px;\n  background: #ffffff;\n}\n\n.guided-highlight-hover-tooltip__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.guided-highlight-hover-tooltip__meaning {\n  font-size: 0.78rem;\n  line-height: 1.35;\n  font-weight: 700;\n}\n\n.guided-highlight-hover-tooltip__purpose {\n  margin-top: 0.32rem !important;\n  font-size: 0.77rem;\n  line-height: 1.4;\n}\n\n.guided-highlight-hover-tooltip__footer {\n  margin-top: 0.62rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(96, 165, 250, 0.18);\n  font-size: 0.68rem;\n  line-height: 1.35;\n  color: #bfdbfe;\n}\n\n.guided-highlight-hover-tooltip__footer strong {\n  margin-left: 0.2rem;\n  color: #93c5fd;\n  font-weight: 700;\n}\n\n.guided-highlight-hover-tooltip.light {\n  border-color: #bfdbfe;\n  background: #ffffff;\n  color: #1f2937;\n  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.2);\n}\n\n.light .guided-highlight-hover-tooltip__purpose {\n  color: #334155;\n}\n\n.light .guided-highlight-hover-tooltip__footer {\n  border-top-color: rgba(59, 130, 246, 0.16);\n  color: #4b5563;\n}\n\n.light .guided-highlight-hover-tooltip__footer strong {\n  color: #1d4ed8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
